import { useState, useEffect, useCallback } from 'react'
import { getNextResetUTC, getTimeRemaining, type TimeRemaining } from '@/utils/timer'
import { useOfferReset } from './useOfferReset'

/**
 * Countdown to the next reset of the offer on screen. Offers reset in their own
 * timezone, so the target comes from the server (`overflow_window.resets_at_utc`)
 * rather than being computed as the next midnight UTC.
 */
export function useResetTimer(): TimeRemaining {
  const { nextReset } = useOfferReset()
  const compute = useCallback(() => getTimeRemaining(getNextResetUTC(nextReset)), [nextReset])
  const [remaining, setRemaining] = useState<TimeRemaining>(compute)

  useEffect(() => {
    setRemaining(compute())
    const interval = setInterval(() => {
      setRemaining(compute())
    }, 1000)
    return () => clearInterval(interval)
  }, [compute])

  return remaining
}
